import { IPagination } from './playbook.type'

export type IResponse<T> = {
  data?: T
  message: string
  success: boolean
  pagination?: IPagination
}

/*
 * Used to wrap an AxiosError or indicate an HTTP 200 with `success: false` in the JSON body.
 * This lets us handle both kind of errors consistently.
 */
export class ResponseError extends Error {}
